var exports = {
  "O0": "MenuItemRadio.module__radioButton___SHJFb2",
  "X3": "MenuItemRadio.module__radioButtonSelected___SHJFb2",
  "EC": "MenuItemRadio.module__radioButtonUnselected___SHJFb2",
  "$l": "MenuItemRadio.module__radioIndicator___SHJFb2",
  "aT": "MenuItemRadio.module__labelContent___SHJFb2",
  "Kk": "MenuItemRadio.module__icon___SHJFb2",
  "QK": "MenuItemRadio.module__labelText___SHJFb2",
};

module.exports = exports;
